export default "__VITE_ASSET__whUI7my8__"